import { render, staticRenderFns } from "./liveliveInformation.vue?vue&type=template&id=27eb86b4&scoped=true"
import script from "./liveliveInformation.vue?vue&type=script&lang=js"
export * from "./liveliveInformation.vue?vue&type=script&lang=js"
import style0 from "./liveliveInformation.vue?vue&type=style&index=0&id=27eb86b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb86b4",
  null
  
)

export default component.exports